'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');

/**
 * 柱状图
 */
var BarChart = React.createClass({

  render: function () {
    var h = styleHelper.getHeight(this.props);
    var chartHeight = Math.round(h / 7);
    var offset = chartHeight;
    var chart1Style = {
      top: offset
    };
    offset = chartHeight * 2 + 6;
    var chart2Style = {
      top: offset
    };
    offset = chartHeight * 4;
    var chart3Style = {
      top: offset
    };
    offset = chartHeight * 5 + 6;
    var chart4Style = {
      top: offset
    };
    return (<div className="content">
      <div className="chart-one" style={chart1Style}/>
      <div className="chart-two" style={chart2Style}/>
      <div className="chart-three" style={chart3Style}/>
      <div className="chart-four" style={chart4Style}/>
    </div>);
  }

});

module.exports = BarChart;



// WEBPACK FOOTER //
// ./src/views/Components/BarChart.jsx